import React from "react";
import WithdrawPendingSection from "../sections/WithdrawPendingSection/Content";
const WithdrawPendingPage = () => {
  return <WithdrawPendingSection />;
};

export default WithdrawPendingPage;
